module.exports = __webpack_public_path__ + "images/vector/app/web/src/assets/tick white-2ab9d99c.svg";


//////////////////
// WEBPACK FOOTER
// ./app/web/src/assets/tick white.svg
// module id = ./app/web/src/assets/tick white.svg
// module chunks = 0